import { useCallback } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useOperationsService, DriftDashboard } from '../services/operationsService';
import { kernelKeys } from './queryKeys';

export function useDriftDashboard() {
  const service = useOperationsService();

  const query = useQuery({
    queryKey: kernelKeys.driftDashboard(),
    queryFn: () => service.getDriftDashboard(),
  });

  const { refetch } = query;
  const refresh = useCallback(() => {
    refetch();
  }, [refetch]);

  return {
    data: (query.data ?? null) as DriftDashboard | null,
    loading: query.isFetching,
    error: query.error
      ? query.error instanceof Error
        ? query.error.message
        : 'Failed to load drift dashboard'
      : null,
    refresh,
  };
}
